/**
 * External dependencies
 */
import React from 'react';
import { connect } from 'react-redux';
import page from 'page';

/**
 * Internal dependencies
 */
import Main from 'components/main';
import DocumentHead from 'data/document-head';
import Topbar from 'modules/me/topbar';
import SelectBarcodeLookupPlan from 'modules/me/select-barcode-lookup-plan';
import { Stack, Text, Heading, Box } from '@towersystems/towersystems-design-system';
import AnnotatedSection from 'components/annotated-section';
import Notice from 'components/notice';
import { getBusinessName } from 'state/current-user/selectors';

/**
 * Style dependencies
 */
import './styles.scss';


const NewPlan = ({ businessName }) => {
    
    const onSuccessPlanSelect = () => {
        page.redirect('/dashboard/barcode-lookup');
    };

    return (
        <Box>
            <DocumentHead title='Billing - Tower Systems' />
            <Topbar title='Barcode Lookup Module' subTitle={'Hello ' + businessName} selected='dispatch' />
            <Box marginBottom='xxlarge'>
                <Text className="plan__content">
                Barcode lookup is a new facility designed to save you time and effort adding new stock items into your Retailer Data.  
                If found, it will pre-add the Name, Extended/web Description, images and other stock item specific information directly into your data.     
                Please note: We are using an external service and we cannot guarantee the accuracy or quality of the data provided. 
                </Text>
            </Box>
            <Main padding='xxlarge'>
                <Stack space='xxlarge'>
                    <Box>
                        <Heading level='3'>Select a Barcode Lookup Module plan</Heading>
                        <Text>
                            *Prices are excluding any applicable discounts. Please click on a plan below to subscribe.
                        </Text>
                    </Box>
                    <Box>
                        <SelectBarcodeLookupPlan afterSuccess={onSuccessPlanSelect} />
                    </Box>
                </Stack>
            </Main>
        </Box>
    );
};

export default connect((state) => ({businessName: getBusinessName(state),}), {})(NewPlan);
